import { AddDiscountCodeResult } from '../../../graphql/cart/addDiscountCode';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { createAction } from '@reduxjs/toolkit';

export interface ApiAddDiscountCodeRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly code: string;
  readonly parentActionId: number;
}

export const apiAddDiscountCodeRequestedType = 'api/cart/addDiscountCode--requested';
export const apiAddDiscountCodeRequested = createAction<ApiAddDiscountCodeRequestedPayload>(
  apiAddDiscountCodeRequestedType
);

export type ApiAddDiscountCodeRequestedAction = ReturnType<typeof apiAddDiscountCodeRequested>;

export interface ApiAddDiscountCodeSucceededPayload {
  readonly cartId: string;
  readonly code: string;
  readonly result: AddDiscountCodeResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiAddDiscountCodeSucceededType = 'api/cart/addDiscountCode--succeeded';
export const apiAddDiscountCodeSucceeded = createAction<ApiAddDiscountCodeSucceededPayload>(
  apiAddDiscountCodeSucceededType
);

export type ApiAddDiscountCodeSucceededAction = ReturnType<typeof apiAddDiscountCodeSucceeded>;

export interface ApiAddDiscountCodeFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiAddDiscountCodeFailedType = 'api/cart/addDiscountCode--failed';
export const apiAddDiscountCodeFailed = createAction<ApiAddDiscountCodeFailedPayload>(
  apiAddDiscountCodeFailedType
);
export type ApiAddDiscountCodeFailedAction = ReturnType<typeof apiAddDiscountCodeFailed>;
